module.exports = __webpack_public_path__ + "static/media/letter-spacing.8a981dc5.svg";